import LineStyleIcon from '@mui/icons-material/LineStyle';
import { SvgIconProps } from '@mui/material';

export const D3Icon = (props: SvgIconProps) => {
  return <LineStyleIcon sx={{ transform: 'rotate(90deg)' }} {...props} />;
};
